<template>
    <div>
        <el-card>
            <div slot="header">
                <span class="top_title">库存明细</span>
            </div>
            <div class="searchItem">
                <div class="search">
                    <span class="searchtips">仓库:</span>
                    <el-select
                        v-model="searchDate.wid"
                        placeholder=""
                        clearable
                        multiple
                        collapse-tags
                        @visible-change="$forceUpdate()"
                        style="width:160px"
                    >
                        <el-option
                            v-for="(item, index) in wList"
                            :key="index"
                            :value="item.id"
                            :label="item.name"
                            style="
                                height: 40px;
                                padding: 10px;
                                line-height: 20px;
                            "
                        />
                    </el-select>
                </div>
                <div class="search">
                    <span class="searchtips">商品:</span>
                    <el-input
                        v-model="searchDate.pname"
                        style="width:180px"
                        clearable
                    >
                    </el-input>
                </div>
                <div class="search">
                    <span class="searchtips">客户名称:</span>
                    <el-input
                        v-model="searchDate.cname"
                        style="width:180px"
                        clearable
                    >
                    </el-input>
                </div>
                <div class="search">
                    <span class="searchtips">颜色:</span>
                    <el-input
                        v-model="searchDate.color"
                        style="width:180px"
                        clearable
                    >
                    </el-input>
                </div>
                <div class="search">
                    <span class="searchtips">尺码:</span>
                    <el-input
                        v-model="searchDate.size"
                        style="width:180px"
                        clearable
                    >
                    </el-input>
                </div>
                <div class="search">
                    <el-button type="primary" icon="el-icon-search" @click="searchOrder()">查询</el-button>
                </div>
                <div class="search">
                    <el-button
                        type="primary"
                        icon="el-icon-printer"
                        @click="print"
                        v-if="$common.checkWindowsEnv()"
                        >打印</el-button>
                    <el-button
                        type='primary'
                        icon="el-icon-document"
                        @click="changePdf"
                    >导出</el-button>
                </div>
            </div>
            <el-table
                v-loading="loading"
                :data="tableData"
                style="
                    width: 100%;
                    margin-top: 20px;
                    margin-bottom: 20px;
                "
                border
            >
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-table :data="props.row.detail">
                            <el-table-column prop="wname" label="仓库名称">
                            </el-table-column>
                            <el-table-column label="辅助属性">
                                <template slot-scope="props">
                                    <div>{{props.row.color?props.row.color+'-'+props.row.size:'默认'}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="inStockDesc" label="总入库">
                            </el-table-column>
                            <el-table-column prop="odUnitDesc" label="订货">
                            </el-table-column>
                            <el-table-column prop="sendedDesc" label="已发">
                            </el-table-column>
                            <el-table-column prop="notSendDesc" label="未发">
                            </el-table-column>
                            <el-table-column prop="totalstock" label="商品库存">
                            </el-table-column>
                            <el-table-column prop="sprice" label="价格(元)">
                            </el-table-column>
                            <el-table-column prop="sumPrice" label="总价(元)">
                            </el-table-column>
                        </el-table>
                    </template>
                </el-table-column>
                <template v-for="(col, index) in cols">
                    <el-table-column 
                        :key="index"
                        :prop="col.prop" 
                        :label="col.label" 
                        :width="col.width"
                        :min-width="col.min_width"
                        align="left"
                    >
                        <template #header v-if="col.column">
                            {{col.label}}
                            <el-button circle icon="el-icon-top" size="mini" v-if="searchDate.column==col.column&&searchDate.order==true" type="primary" @click="setSort(col.column,true)"></el-button>
                            <el-button circle icon="el-icon-top" size="mini" v-else @click="setSort(col.column,true)"></el-button>
                            <el-button circle icon="el-icon-bottom" size="mini" v-if="searchDate.column==col.column&&searchDate.order==false" type="primary" @click="setSort(col.column,false)"></el-button>
                            <el-button circle icon="el-icon-bottom" size="mini" v-else @click="setSort(col.column,false)"></el-button>
                        </template>
                        <template slot-scope="{ row }">
                            <template>
                                <div>{{row[col.prop]}}</div>
                            </template>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
            <el-pagination
                style="text-align: right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 120, 250]"
                :page-size="cp_pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                :pager-count="5"
            >
            </el-pagination>
        </el-card>
        <ReportOrder ref="roder"></ReportOrder>
        <edit-share ref="share"></edit-share>
    </div>
</template>

<script>
import ReportOrder from '@/components/printshare/reportorder.vue';
import editShare from '@/components/printshare/edit_share';
export default {
    components:{
        ReportOrder,editShare
    },
    data() {
        return {
            loading:false,
            searchDate: {
                pname:"",
                wid:[],
                cname:'',
                column:'',
                order:'',
                color:'',
                size:'',
            },
            wList:[],
            currentPage: 1,
            cp_pagesize: 10,
            total: 100,
            tableData: [],
            searchObj:{},
            cols:[
                {
                    label:'商品编号',
                    prop:'pnumber',
                    column:'pnumber',
                    width:'160'
                },{
                    label:'商品名称',
                    prop:'pname',
                    width:'160'
                },{
                    label:'总入库',
                    prop:'inStockDesc',
                    width:'120'
                },{
                    label:'订货',
                    prop:'odUnitDesc',
                    width:'120'
                },{
                    label:'已发',
                    prop:'sendedDesc',
                    width:'120'
                },{
                    label:'未发',
                    prop:'notSendDesc',
                    width:'120'
                },{
                    label:'商品库存',
                    prop:'totalstock',
                    width:'160',
                    column:'sumAmount',
                },{
                    label:'总价(元)',
                    prop:'sumPrice',
                    width:'120'
                }
            ]
        };
    },
    created() {
        this.tableData = [];
        this.searchObj = {
            page: this.currentPage,
            limit: this.cp_pagesize,
        };
        this.getProductStock();
        this.getWareHouse();
    },
    methods: {
        print(){
			let array = [];
			let cmp = this.$global.cmpId.cmp;
			array.push(cmp);
			this.$nextTick(()=>{
				this.$refs.roder.extraOpen(9,array);
			})
		},
		changePdf(){
			let array = [1];
			this.$nextTick(()=>{
				this.$refs.share.openList(array,9,this.searchObj);
			})
		},
        getWareHouse(){
            this.$api.listWareHouse().then((res)=>{
                if(res.data.code==1){
                    let data =res.data.data;
                    this.wList = data;
                }
            })
        },
        searchOrder(){
            this.searchObj = {
                page: 1,
                limit: this.cp_pagesize,
            };
            this.currentPage = 1;
            if(this.searchDate.pname){
                this.searchObj.pname = this.searchDate.pname;
            }
            if(this.searchDate.wid.length>0){
                this.searchObj.wid = this.searchDate.wid.join(',');
            }
            if(this.searchDate.cname){
                this.searchObj.cname = this.searchDate.cname;
            }
            if(this.searchDate.color){
                this.searchObj.color = this.searchDate.color;
            }
            if(this.searchDate.size){
                this.searchObj.size = this.searchDate.size;
            }
            this.searchObj.send = 0;
            this.sortTime();
        },
        setSort(column,order){
            if(this.searchDate.column==column&&this.searchDate.order==order){
                this.searchDate.column = '';
                this.searchDate.order = '';
            }else{
                this.searchDate.column = column;
                this.searchDate.order = order;
            }
            this.sortTime();
        },
        sortTime(){
            if(this.searchDate.column){
                this.searchObj.column = this.searchDate.column;
                this.searchObj.order = this.searchDate.order?'asc':'desc';
            }else{
                delete this.searchObj.column;
                delete this.searchObj.order;
            }
            this.getProductStock();
        },
        handleSizeChange(val) {
            this.cp_pagesize = val;
            this.searchOrder();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.searchObj.page = val;
            this.getProductStock();
        },
        getProductStock() {
            this.loading = true;
            this.$api.getProductStock(this.searchObj).then((res) => {
                if (res.data.code == 1) {
                    this.tableData = [];
                    let data = res.data.data;
                    this.total = res.data.count;
                    if(data!=null&&data.length>0){
                        data.forEach(e => {
                            e.totalstock = this.$common.changeNumDesc(e,'stockAmount','stockParts','stock');
                            e.inStockDesc = this.$common.changeNumDesc(e,'inStockAmount','inStockParts','inStock');
                            e.odUnitDesc = this.$common.changeNumDesc(e,'odAmount','odParts','odUnit');
                            e.sendedDesc = this.$common.changeNumDesc(e,'sendedAmount','sendedParts','sendedUnit');
                            e.notSendDesc = this.$common.changeNumDesc(e,'notSendAmount','notSendParts','notSendUnit');
                            e.detail.forEach(s=>{
                                s.totalstock = this.$common.changeNumDesc(s,'stockAmount','stockParts','stock');
                                s.inStockDesc = this.$common.changeNumDesc(s,'inStockAmount','inStockParts','inStock');
                                s.odUnitDesc = this.$common.changeNumDesc(s,'odAmount','odParts','odUnit');
                                s.sendedDesc = this.$common.changeNumDesc(s,'sendedAmount','sendedParts','sendedUnit');
                                s.notSendDesc = this.$common.changeNumDesc(s,'notSendAmount','notSendParts','notSendUnit');
                            })
                            this.tableData.push(e);
                        });
                    }
                    this.loading = false;
                }
            });
        },
    },
};
</script>